/**
 * Shopify order names arrive verbatim from the API — typically `#162410` —
 * and that '#'-prefixed form is the external join key (`orders.order_name`,
 * webhook payloads, Pipe17/Portless references). Never strip it at write
 * time or in API payload mapping; only the render/barcode layer normalizes
 * it for humans and scanners.
 */
/**
 * Data-level strip: barcode payloads, generated filenames, clipboard copy.
 * Anchored to a leading run of '#' so a value that never had one is a no-op.
 */
export function stripOrderNamePrefix(name) {
    if (name === null || name === undefined)
        return '';
    return name.trim().replace(/^#+/, '');
}
/**
 * Display convention: bare number, no leading '#'. Kept as a separate named
 * export from `stripOrderNamePrefix` so the display convention can change
 * independently of the data-level strip.
 */
export function formatOrderNumber(name) {
    return stripOrderNamePrefix(name);
}
